import { Heading, Text, Image, Box } from "@chakra-ui/react";
import image1 from "../images/image012.jpg";
import image2 from "../images/image013.png";
import image3 from "../images/image017.jpg";
import image4 from "../images/image020.jpg";
import image5 from "../images/image005.jpg";
import image6 from "../images/image006.jpg";
import image7 from "../images/image007.jpg";
import image8 from "../images/image008.jpg";

export default function Guidelines() {
  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    flexDirection: "row",
    width: "100%",
    pt: "5px",
    pb: "5px",
  };
  const bulletTextStyle = {
    fontSize: { base: "md", md: "lg", xl: "xl" },
    fontWeight: 600,
    color: "white",
  };
  const textStyle = {
    fontSize: { base: "md", md: "lg", xl: "2xl" },
    color: "white",
  };
  return (
    <div id='instructions'>
      <Box
        ml='auto'
        mr='auto'
        mt='90px'
        mb='10px'
        width={{ base: "90%", md: "90%", xl: "77%" }}
        background='rgba(31, 159, 181, 0.3)'
        borderRadius='md'
        textAlign='start'
        pl='12px'
        pb='12px'
      >
        <Box textAlign='center'>
          <Heading
            fontFamily='Fjord One'
            size='xl'
            fontWeight={600}
            color='white'
          >
            Image Capturing Guidelines
          </Heading>
        </Box>

        <Text style={textStyle}>
          {" "}
          Our marking algorighm analyses and defines the quality of hypospadias
          urethral plate. To ensure high accuracy, please follow these
          guidelines while capturing the images.
        </Text>
        <Text style={bulletTextStyle}>1. Distance</Text>
        <Text style={textStyle}>
          Images must be taken 20-25cm away from the patient
        </Text>
        <Box style={style}>
          <Image
            src={image1}
            alt='image1'
            width={{ base: "45%", md: "35%", xl: "30%" }}
          />
          <Image
            src={image2}
            alt='image2'
            width={{ base: "27%", md: "21%", xl: "18%" }}
          />
        </Box>

        <Text style={bulletTextStyle}>2. Image Resolution</Text>
        <Text style={textStyle}>
          Images must be taken using high quality digital camera
        </Text>
        <Box style={style}>
          <Image
            src={image3}
            alt='image3'
            width={{ base: "27%", md: "21%", xl: "18%" }}
          />
          <Image
            src={image4}
            alt='image4'
            width={{ base: "44%", md: "35%", xl: "30%" }}
          />
        </Box>

        <Text style={bulletTextStyle}>3.Camera angle</Text>
        <Text style={textStyle}>
          Images must be taken from a front point of view(medially) not from a
          side point of view(laterally).
        </Text>
        <Box style={style}>
          <Image
            src={image5}
            alt='image5'
            width={{ base: "44%", md: "30%", xl: "23%" }}
          />
          <Image
            src={image6}
            alt='image6'
            width={{ base: "34%", md: "23%", xl: "18%" }}
          />
        </Box>
        <Text style={bulletTextStyle}>4.Lighting</Text>
        <Text style={textStyle}>
          Images must be taken in a good lighting condition and shadows should
          be avoided.
        </Text>
        <Box style={style}>
          <Image
            src={image7}
            alt='image7'
            width={{ base: "41%", md: "27%", xl: "22%" }}
          />
          <Image
            src={image8}
            alt='image8'
            width={{ base: "35%", md: "23%", xl: "19%" }}
          />
        </Box>
      </Box>
    </div>
  );
}
